import { useEffect, useState } from "react";
import { BACKEND } from "./api";

let tick = 0;
const listeners = new Set();
let started = false;
let timer = null;

const bump = () => {
  clearTimeout(timer);
  timer = setTimeout(() => { tick += 1; listeners.forEach((fn) => fn(tick)); }, 300);
};

function start() {
  if (started || typeof window === "undefined") return;
  started = true;
  if ("EventSource" in window) {
    const es = new EventSource(`${BACKEND}/api/live`);
    es.onmessage = () => bump();
  }
  setInterval(bump, 60000);
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && bump());
}

export function useLiveTick() {
  const [t, setT] = useState(tick);
  useEffect(() => {
    start();
    listeners.add(setT);
    return () => listeners.delete(setT);
  }, []);
  return t;
}
